import {
	InputField,
	Select,
	TableFilterWrapper,
} from '@welbe/web-design-system';
import { OptionProps } from '@welbe/web-design-system/lib/components/molecules/Select/Select';
import useBranchOfficeSelect from 'Factories/filters/hooks/useBranchOfficeSelect';
import { useEffect, useRef } from 'react';
import { handleKeyPress } from 'utils/keyPressHandler';

type EmployeeFiltersProps = {
	sequence: number;
	loading: boolean;
	height: number;
	onChangeFilters: (filter: { [key: string]: any }) => void;
	onSearch: () => void;
};

const statusEnum: { [key: string]: OptionProps[] } = {
	riskLevel: [
		{ id: 'Muy alto', value: 'Muy alto' },
		{ id: 'Alto', value: 'Alto' },
		{ id: 'Medio', value: 'Medio' },
		{ id: 'Bajo', value: 'Bajo' },
		{ id: 'Nulo', value: 'Nulo' },
	],
	status: [
		{
			value: 'Agendado',
			id: 'scheduled',
		},
		{
			value: 'Rechazado',
			id: 'canceled',
		},
		{
			value: 'Realizado',
			id: 'finished',
		},
		{
			value: 'Por referir',
			id: 'toRefer',
		},
		{
			value: 'Referido',
			id: 'pending',
		},
	],
};

const statusNameType: { [key: string]: string } = {
	riskLevel: 'Nivel de riesgo',
	status: 'Estatus',
};

const resultEnum = [
	{ id: '', value: '' },
	{ id: 'notRequireAttention', value: 'No requiere atención' },
	{ id: 'requireAttention', value: 'Requiere atención' },
	{ id: 'notAnswered', value: 'Sin Respuesta' },
];

export const CollaboratorFilters = ({
	height,
	onChangeFilters,
	sequence,
	loading,
	onSearch,
}: EmployeeFiltersProps) => {
	const statusName = sequence === 0 ? 'status' : 'riskLevel';
	const {
		branchOfficeOptions,
		selectedBranchOffice,
		isLoadingBranchOffice,
		handleSelectBranchOffice,
	} = useBranchOfficeSelect();

	const appliedBranchOfficeId = useRef('');

	useEffect(() => {
		const branchOfficeId = selectedBranchOffice?.id || '';
		if (branchOfficeId === appliedBranchOfficeId.current) return;

		appliedBranchOfficeId.current = branchOfficeId;
		onChangeFilters({ branchOfficeId });
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [selectedBranchOffice]);

	return (
		<TableFilterWrapper height={height}>
			<InputField
				id="employee"
				label="Colaboradores"
				placeholder="Busca por colaborador"
				background="white"
				disabled={loading}
				onKeyPress={(e) => handleKeyPress(e, onSearch)}
				onChange={(data) => onChangeFilters({ employee: data })}
			/>
			<Select
				id="candidateBranchOffice"
				disabled={isLoadingBranchOffice}
				inputBackground="white"
				placeholder="Selecione..."
				loading={isLoadingBranchOffice}
				label="Sucursal"
				required
				initialSelected={selectedBranchOffice}
				options={branchOfficeOptions}
				onChange={handleSelectBranchOffice}
			/>
			<Select
				id="result"
				label="Resultados"
				placeholder="Selecciona un resultado"
				inputBackground="white"
				loading={loading}
				options={resultEnum}
				onChange={(select) => onChangeFilters({ result: select.id || '' })}
			/>
			<Select
				id="status"
				label={statusNameType[statusName]}
				placeholder="Selecciona un estatus"
				inputBackground="white"
				loading={loading}
				options={[{ id: '', value: '' }, ...statusEnum[statusName]]}
				onChange={(select) => onChangeFilters({ status: select.id || '' })}
			/>
		</TableFilterWrapper>
	);
};
